import { h } from 'preact'; 
import { lazy, Suspense } from 'preact/compat';

import CategoryBreadcrumbs from '@ui/Archive/BreadcrumbsCategory';
import ManufacturerBreadcrumbs from '@ui/Archive/BreadcrumbsManufacturer';
import SearchBreadcrumbs from '@ui/Archive/BreadcrumbsSearch';
import TagBreadcrumbs from '@ui/Archive/BreadcrumbsTag';

export default function getPageBreadcrumbs(pageType) {
    switch (pageType) {
        case 'category': 
            return <CategoryBreadcrumbs />
        
        case 'manufacturer':
            return <ManufacturerBreadcrumbs />
        
        case 'search':
            return <SearchBreadcrumbs />
        
        case 'tags': 
            return <TagBreadcrumbs />
        
        default:
            return null; 
    }
}